
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.64 1.707a10.282 10.282 0 00-3.632.793 10.392 10.392 0 00-2.95 1.887 13.05 13.05 0 00-.91.941 10.3 10.3 0 00-2.418 5.879 11.761 11.761 0 000 1.574c.063.84.23 1.672.493 2.465a10.32 10.32 0 006.539 6.527c1.73.575 3.61.672 5.402.29a10.239 10.239 0 004.602-2.31 10.28 10.28 0 003.43-6.32c.034-.257.062-.55.081-.859a19.02 19.02 0 000-1.156 10.273 10.273 0 00-1.809-5.277 10.36 10.36 0 00-4.3-3.563 10.303 10.303 0 00-3.41-.851c-.336-.024-.82-.032-1.117-.02zm.684 1.387a8.893 8.893 0 016.442 3.11 8.872 8.872 0 012.078 4.75c.047.394.062.714.054 1.16a8.44 8.44 0 01-.195 1.769 8.895 8.895 0 01-2.926 4.89 8.89 8.89 0 01-4.886 2.086c-.336.032-.47.04-.887.04-.477 0-.719-.016-1.149-.067a8.94 8.94 0 01-3.394-1.168 8.922 8.922 0 01-1.399-1.027c-.242-.211-.625-.606-.855-.875a8.918 8.918 0 01-1.863-7.88 8.474 8.474 0 01.687-1.87 8.73 8.73 0 011.61-2.254 8.88 8.88 0 016.683-2.664zm0 0"}}),_c('path',{attrs:{"d":"M11.766 3.516a8.498 8.498 0 00-7.34 4.652 8.412 8.412 0 00-.906 4.062c.023.844.16 1.63.417 2.418a8.505 8.505 0 003.954 4.77c.156.09.496.258.66.332a8.435 8.435 0 002.574.684c.48.05 1.059.058 1.543.02a8.48 8.48 0 007.566-6.438c.121-.48.192-.942.23-1.477.005-.062.009-.254.013-.426a8.66 8.66 0 00-.024-.804A8.459 8.459 0 0018.52 6.57a9.107 9.107 0 00-1.024-1.03 8.698 8.698 0 00-2.055-1.298 8.484 8.484 0 00-3.675-.726zm4.617 4.539v.906h-3.211v4.496c0 3.777 0 4.5-.012 4.508-.004.004-.316.008-1.168.008l-1.164-.004v-4.504l-.004-4.504H7.61v-.902c0-.496 0-.903.004-.907 0-.004 1.977-.004 4.387-.004h4.383zm0 0"}})])
          )
        }
      }
    